import {
    LinkBlocksWidgetLink,
    LinkBlocksWidgetLinkHeader,
    LinkBlocksWidgetLinkTargetUrl,
} from './types'

export function getLinkBlockTargetType(link?: LinkBlocksWidgetLink) {
    return link?.link?.type || 'url'
}

export function getLinkBlockLabel(link: LinkBlocksWidgetLink) {
    if (!!link.title) {
        return link.title
    }

    if (!!link.link) {
        let label = link.link.label
        if (!!label) return label

        // For external links, we want to return the href if it exists.
        const linkType = getLinkBlockTargetType(link)
        if (linkType === 'url' && !!(link.link as LinkBlocksWidgetLinkTargetUrl).href) {
            return (link.link as LinkBlocksWidgetLinkTargetUrl).href
        }
    }

    return 'Link block'
}

export function isInlineLink(
    link: LinkBlocksWidgetLink,
    headerType?: LinkBlocksWidgetLinkHeader['type']
) {
    return !link.title && !link.subtitle && headerType !== 'image' && !!link.link
}

export function isEmptyLink(link: LinkBlocksWidgetLink) {
    return !link.title && !link.subtitle && !link.link && !link.header
}

export function getLinkTargetFields(fields: FieldDto[]) {
    return fields.filter((field) => ['string', 'url', 'multi_file'].includes(field.type))
}
